"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ContentType = {
  Path: 'Path',
  CheckpointReview: 'Checkpoint Review',
  Course: 'Course',
  ILT: 'ILT',
  Checkpoint: 'Checkpoint'
};
var _default = ContentType;
exports.default = _default;